import {createSelector} from "reselect";

const parrainagesSelector = state => state.parrainages

export const getDataParrainages = createSelector(
    parrainagesSelector,
    parrainages => parrainages
)
